import { Component, Input, Optional, Self, ElementRef, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AtpHttpService, IAtpUser } from '../../services/atp-http.service';
import { HttpResponse } from '@angular/common/http';
import { AtpHttpErrorsService } from '../../services/atp-http-errors.service';
import { AtpDateTimeService } from '../atp-range-date-time-picker/atp-date-time.service';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FocusMonitor } from '@angular/cdk/a11y';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

export interface IAtpSelectedFile {
  id?: string;
  file?: File;
  percentUploading?: number;
  name?: string;
  size?: number;
  date?: Date;
}

@Component({
  selector: 'atp-upload-file',
  templateUrl: './atp-upload-file.component.html',
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: AtpUploadFileComponent
    }
  ],
  host: {
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
    'class': "atp-upload-file-component"
  }
})
export class AtpUploadFileComponent implements OnInit {

  @Input() fieldName: string;

  constructor(protected api: AtpHttpService<IAtpUser>, protected httpErrors: AtpHttpErrorsService, protected datetimeService: AtpDateTimeService, public focusMonitor: FocusMonitor, private _elementRef: ElementRef<HTMLElement>, @Optional() @Self() public ngControl: NgControl) {
    focusMonitor.monitor(_elementRef, true).subscribe(origin => {
      setTimeout(() => {
        if (this.focused && !origin) {
          this.onTouched();
          this.stateChanges.next();
        }
        this.focused = !!origin;
      }, 0);
    });

    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    // console.log(123123);
    // setTimeout(() => {
    //   console.log([
    //     this.ngControl,
    //     this.ngControl.control,
    //     this.errorState,
    //     this.ngControl.errors
    //   ]);
    //   this.errorState = !!this.ngControl.errors;
    //   this.stateChanges.subscribe(
    //     data => {
    //       if (this.ngControl && this.ngControl.control) {
    //         this.errorState = !!this.ngControl.errors;
    //       }
    //     }
    //   );
    // }, 0);
  }

  static nextId = 0;
  stateChanges = new Subject<void>();
  id: string = `atp-upload-file-${AtpUploadFileComponent.nextId++}`;

  onChange = (_: any) => { };
  onTouched: any = () => { };

  private _placeholder: string;
  @Input() get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }

  focused: boolean;
  empty: boolean;

  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  private _required = false;
  @Input() get required(): boolean {
    return this._required;
  }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  private _disabled = false;
  @Input() get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  // errorState: boolean;
  controlType: string = 'atp-upload-file';
  autofilled?: boolean;
  describedBy = '';

  setDescribedByIds(ids: string[]): void {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent): void {
    // if ((event.target as Element).tagName.toLowerCase() != 'input') {
    //   this._elementRef.nativeElement.querySelector('input')!.focus();
    // }
  }

  writeValue(value: any): void {
    if (value && value.id) {
      if (value.date && typeof (value.date) == 'string') {
        value.date = new Date(value.date);
      }
      this.value = [value];
    }
    else {
      if (value && value.length) {
        for (const item of value) {
          if (item.date && typeof (item.date) == 'string') {
            item.date = new Date(item.date);
          }
        }
      }
      this.value = value;
    }
    if (value && typeof (value) != 'string' && this.uploadingFiles.length == 0 && this.value) {
      for (const item of (<IAtpSelectedFile[]>this.value)) {
        this.uploadingFiles.push(item);
        this.selectedFiles.push(item);
      }
    }
  }

  private _value: IAtpSelectedFile[] | IAtpSelectedFile;
  get value(): IAtpSelectedFile[] | IAtpSelectedFile {
    return this._value;
  }
  set value(val: IAtpSelectedFile[] | IAtpSelectedFile) {
    if (!val || !(<IAtpSelectedFile[]>val).length) {
      this._value = null;
    }
    else {
      this._value = val;
    }

    if (this.notAllowedList && this.notAllowedList.length) {
      (<any>this._value) = 'Invalid';
    }

    this.onChange(this._value);
    this.onTouched();
    this.stateChanges.next();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  @Input() multiple: boolean;
  @Input() maxSize: number;
  @Input() formatsAllowed: string;
  @Input() maxCount: number = 1;

  canClicked: boolean = true;

  icons = {
    txt: 'text_format'
  };

  getIcon(name: string): string {
    let icon = 'description';
    if (name.lastIndexOf('.') > -1) {
      icon = this.icons[name.substr(name.lastIndexOf('.') + 1)];
    }

    return icon || 'description';
  }

  uploadingFiles: IAtpSelectedFile[] = [];

  selectedFiles: IAtpSelectedFile[] = [];

  idDate: number = +new Date();
  reg: RegExp = /(?:\.([^.]+))?$/;
  notAllowedList: Array<Object> = [];

  onValueChange(event: any) {
    if (!this.selectedFiles) {
      this.selectedFiles = [];
    }
    this.notAllowedList = [];
    if (!this.multiple) {
      this.selectedFiles = [];
    }
    else if (this.selectedFiles.length == this.maxCount) {
      return;
    }

    let formatsCount: any;
    formatsCount = this.formatsAllowed == '*' ? 0 : this.formatsAllowed.match(new RegExp("\\.", "g"));
    formatsCount = formatsCount.length;

    let files: FileList;
    if (event.type == 'drop') {
      files = event.dataTransfer.files;
    } else {
      files = event.target.files || event.srcElement.files;
    }

    this.maxCount = this.multiple ? this.maxCount : 1;

    let currentFileExt: any;
    let ext: any;
    let frmtAllowed: boolean;
    for (let i = 0; i < files.length; i++) {
      if (i == this.maxCount - this.selectedFiles.length + i) {
        return;
      }
      currentFileExt = this.reg.exec(files[i].name);
      currentFileExt = currentFileExt[1];
      frmtAllowed = false;
      for (let j = formatsCount; j > 0; j--) {
        ext = this.formatsAllowed.split(".")[j];
        if (j == formatsCount) {
          ext = this.formatsAllowed.split(".")[j] + ',';
        }
        if (currentFileExt.toLowerCase() == ext.split(',')[0]) {
          frmtAllowed = true;
        }
      }

      frmtAllowed = this.formatsAllowed == '*' ? true : frmtAllowed;

      if (frmtAllowed) {
        if (files[i].size > this.maxSize * 1024000) {
          this.notAllowedList.push({
            fileName: files[i].name,
            fileSize: this.convertSize(files[i].size),
            errorMsg: 'Размер файла превышает допустимый.'
          });
          this.value = [];
          continue;
        }
        else {
          let oldFile = this.uploadingFiles.find(x => x.file && x.file.name == files[i].name && x.file.lastModified == files[i].lastModified && x.file.size == files[i].size);
          let oldSelectedFile = this.selectedFiles.find(x => x.file && x.file.name == files[i].name && x.file.lastModified == files[i].lastModified && x.file.size == files[i].size);
          if (oldSelectedFile) {
            continue;
          }
          else if (oldFile) {
            this.selectedFiles.push(oldFile);
            if (this.selectedFiles.filter(x => !x.id).length == 0) {
              this.value = this.selectedFiles.map(x => { return { id: x.id, name: x.name ? x.name : x.file.name, size: x.size || x.size === 0 ? x.size : x.file.size } });
            }
          }
          else {
            let newFile: IAtpSelectedFile = { file: files[i], percentUploading: 0 };
            this.selectedFiles.push(newFile);
            this.uploadingFiles.push(newFile);
            this.uploadFile(newFile);
          }
        }
      }
      else {
        this.notAllowedList.push({
          fileName: files[i].name,
          fileSize: this.convertSize(files[i].size),
          errorMsg: 'Неверный формат файла.'
        });
        this.value = [];
        continue;
      }
    }

    event.target.value = null;
  }

  uploadFile(newFile: IAtpSelectedFile) {
    (<any>this.value) = 'Invalid';
    this.api.uploadFile(newFile.file, this.fieldName).subscribe(
      (event: any) => {
        let percent = Math.round(100 * event.loaded / event.total);
        newFile.percentUploading = isNaN(percent) ? newFile.percentUploading : percent;

        if (event instanceof HttpResponse) {
          if (event.ok) {
            newFile.percentUploading = 100;
            newFile.id = event.body.toString();
            if (this.selectedFiles.filter(x => !x.id).length == 0) {
              this.value = this.selectedFiles.map(x => { return { id: x.id, name: x.name ? x.name : x.file ? x.file.name : '', size: x.size ? x.size : x.file ? x.file.size : 0 } });
            }
          }
          else {
            this.replaceFileFromSelectedToNotAllowed(newFile, 'При загрузке файла произошла ошибка.');
            this.value = [];
          }
        }
      },
      err => {
        if (err.status == 401) {
          this.httpErrors.process(err.status, () => { this.uploadFile(newFile); }, null);
        }
        else {
          this.replaceFileFromSelectedToNotAllowed(newFile, 'При загрузке файла произошла ошибка.');
          this.value = [];
        }
      }
    );
  }

  private replaceFileFromSelectedToNotAllowed(newFile: IAtpSelectedFile, errorMsg: string) {
    this.uploadingFiles.splice(this.uploadingFiles.findIndex(x => x.file.name == newFile.file.name && x.file.lastModified == newFile.file.lastModified && x.file.size == newFile.file.size), 1);
    this.selectedFiles.splice(this.uploadingFiles.findIndex(x => x.file.name == newFile.file.name && x.file.lastModified == newFile.file.lastModified && x.file.size == newFile.file.size), 1);
    this.notAllowedList.push({
      fileName: newFile.file.name,
      fileSize: this.convertSize(newFile.file.size),
      errorMsg: errorMsg
    });
  }

  removeFile(i: any, sf_na: any) {
    if (sf_na == 'sf') {
      this.selectedFiles.splice(i, 1);
    } else {
      this.notAllowedList.splice(i, 1);
    }

    if (this.selectedFiles.filter(x => !x.id).length == 0) {
      this.value = this.selectedFiles.map(x => { return { id: x.id, name: x.name ? x.name : x.file ? x.file.name : '', size: x.size ? x.size : x.file ? x.file.size : 0 } });
    }

    setTimeout(() => {
      this.canClicked = true;
    }, 0);
  }

  convertSize(fileSize: number) {
    return fileSize < 1024000 ? (fileSize / 1024).toFixed(2) + ' KB' : (fileSize / 1024000).toFixed(2) + ' MB';
  }

  drop(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.onValueChange(event);
  }

  allowDrop(event: any) {
    event.stopPropagation();
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
  }

  openFile(id: string) {
    this.api.getFile(id).subscribe(
      (data) => {
      },
      err => {
        this.httpErrors.process(401, () => { this.openFile(id); }, null);
      }
    );
  }

  get errorState() {
    return this.ngControl.errors !== null && !!this.ngControl.touched;
  }
}
